/** True when the browser can create a WebGL 1 or 2 context. */
export function canCreateWebGLContext(): boolean {
  if (typeof document === 'undefined') return false

  try {
    const canvas = document.createElement('canvas')
    return Boolean(canvas.getContext('webgl2') || canvas.getContext('webgl'))
  } catch {
    return false
  }
}

/**
 * True when WebGL is backed by a CPU rasteriser (SwiftShader, llvmpipe, …)
 * rather than a GPU — e.g. machines with GPU acceleration off, and the
 * headless Chrome that PageSpeed Insights tests with. Every frame there is
 * main-thread-heavy CPU work, so animated shaders should paint once instead.
 */
export function isSoftwareWebGLRenderer(): boolean {
  if (typeof document === 'undefined') return false

  try {
    const canvas = document.createElement('canvas')
    const gl = (canvas.getContext('webgl2') ||
      canvas.getContext('webgl')) as WebGLRenderingContext | null
    if (!gl) return false
    const info = gl.getExtension('WEBGL_debug_renderer_info')
    const renderer = String(
      gl.getParameter(info ? info.UNMASKED_RENDERER_WEBGL : gl.RENDERER) ?? '',
    )
    gl.getExtension('WEBGL_lose_context')?.loseContext()
    return /swiftshader|llvmpipe|softpipe|software|basic render/i.test(renderer)
  } catch {
    return false
  }
}
